__turbopack_context__.v({
  "cardsContainer": "serviceCards-module-scss-module__D6f4nG__cardsContainer",
  "serviceCards": "serviceCards-module-scss-module__D6f4nG__serviceCards",
  "text": "serviceCards-module-scss-module__D6f4nG__text",
  "title": "serviceCards-module-scss-module__D6f4nG__title",
});
